import React from 'react';
import { reduxForm, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';

import { CHANGE_PAY_RELEASE_DATE_FORM } from 'src/constants/FormNames';
import { DateField, SelectField, CheckboxField } from 'src/jbc-front/components/Form';
import CommonModal from 'jbc-front/components/CommonModal';
import Button from 'jbc-front/components/Button';
import { FormSubmitBtn } from 'src/buttons';
import { isYYYYMMDDFormat } from 'src/utils/CustomValidators';
import { get24HoursOptions } from 'src/utils/Form';
import { updatePayReleaseDate } from 'src/reducers/employees/employeePays';
import styles from './ChangePayReleaseDateForm.scss';
import { useTranslation } from 'react-i18next';
import { LANGUAGE_OPTIONS } from 'src/constants/Options';
import selector from 'src/utils/Utils';

const ChangeReleaseDateFormInner = ({ isOpen, hideModal, submitting, submit, isSendNotifyToEmployee }) => {
  const { t } = useTranslation();
  return (
    <CommonModal ariaHideApp={false} {...{ isOpen, hideModal }}>
      <CommonModal.Header hideModal={hideModal}>{t('features.EmployeePays.components.ChangePayReleaseDateForm.Disclosure_date_setting')}</CommonModal.Header>
      <CommonModal.Body>
        <form>
          <div className={styles.body}>
            <DateField required name="releaseDate" label={t('features.EmployeePays.components.ChangePayReleaseDateForm.Payslip_disclosure_time_to_employee')} validate={isYYYYMMDDFormat} />
            <div style={{ width: '120px' }}>
              <SelectField required noLabel name="releaseHour" options={get24HoursOptions()} width={100} />
            </div>
            <div>
              <CheckboxField name="sendNotifyToEmployee" label={t('features.EmployeePays.components.ChangePayReleaseDateForm.Send_notification_email_at_the_same_time_as_payslip_disclosure')} />
            </div>
            {isSendNotifyToEmployee && (
              <div style={{ width: '250px' }}>
                <SelectField label={t('features.EmployeePays.components.ChangePayReleaseDateForm.language_of_notification_email')} name="locale" options={LANGUAGE_OPTIONS} required />
              </div>
            )}
          </div>
        </form>
      </CommonModal.Body>
      <CommonModal.Footer>
        <Button onClick={hideModal} className="u-mr20">
          {t('features.EmployeePays.components.PayReportsCreateModal.cancel')}
        </Button>
        <FormSubmitBtn text={t('features.EmployeePays.components.ChangePayReleaseDateForm.Confirm')} {...{ submitting, submit }} />
      </CommonModal.Footer>
    </CommonModal>
  );
};

const ChangePayReleaseDateForm = reduxForm({
  form: CHANGE_PAY_RELEASE_DATE_FORM,
  enableReinitialize: true
})(ChangeReleaseDateFormInner);

const mapStateToProps = (state, ownProps) => {
  const releaseDateTime = _.get(ownProps, 'releaseDate');
  const releaseDate = releaseDateTime ? moment(releaseDateTime).format('DD/MM/YYYY') : null;
  const releaseHour = releaseDateTime ? moment(releaseDateTime).format('H') : null;
  const sendNotifyToEmployee = _.get(ownProps, 'sendNotifyToEmployee');
  const locale = _.get(ownProps, 'locale');

  return {
    initialValues: { releaseDate, releaseHour, sendNotifyToEmployee, locale },
    isSendNotifyToEmployee: selector(getFormValues(CHANGE_PAY_RELEASE_DATE_FORM)(state), 'sendNotifyToEmployee'),
    ...ownProps
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: data => dispatch(updatePayReleaseDate(data, ownProps.hideModal))
});

export default connect(mapStateToProps, mapDispatchToProps)(ChangePayReleaseDateForm);
